import { useAppSelector } from "@/store";
import { useMemo } from "react";
import { IVipRoleType } from "@/services/user";

export function getVipType(vipList?: { tag: IVipRoleType; vip: boolean }[]) {
  //行政班
  const isXzbVIP = vipList?.some((item) => item.tag === "CLASS_VIP" && item.vip);
  const isXzbVIP20240617 = vipList?.some((item) => item.tag === "VIP_KUAIPK_20240617" && item.vip);
  const isXzbVIP20250402 = vipList?.some((item) => item.tag === "VIP_KUAIPK_20250402" && item.vip);
  const isXzbVIP20250506 = vipList?.some((item) => item.tag === "SVIP_KUAIPK_20250506" && item.vip);
  const isInsVIP = vipList?.some((item) => item.tag === "INS_VIP_KUAIPK" && item.vip);
  const isJwCgVip = vipList?.some((item) => item.tag === "KUAIJW_CLASS" && item.vip); // 倍思教务常规排课
  const isJwXgkVip = vipList?.some((item) => item.tag === "KUAIJW_NCEE_CLASS" && item.vip); // 倍思教务新高考排课
  const isJwTdkVip = vipList?.some((item) => item.tag === "KUAIJW_TDK" && item.vip); // 倍思教务新高考排课
  const isJwIntlPkVip = vipList?.some((item) => item.tag === "KUAIGJ_PK" && item.vip); // 倍思教务新高考排课
  const isJwIntlKwglVip = vipList?.some(
    (item) => item.tag === "KUAIGJ_COURSE_MANAGEMENT" && item.vip,
  ); // 倍思教务新高考排课

  const isPersonalVIP = isXzbVIP || isXzbVIP20240617 || isXzbVIP20250402 || isXzbVIP20250506;
  const isJwVip = isJwCgVip || isJwXgkVip || isJwIntlPkVip;

  return {
    isXzbVIP,
    isXzbVIP20240617,
    isXzbVIP20250506,
    isJwCgVip,
    isJwXgkVip,
    isPersonalVIP,
    isInsVIP,
    isJwVip,
    isJwTdkVip,
    isJwIntlPkVip,
    isJwIntlKwglVip,
  };
}

export default function useVipType() {
  const { userVipInfo } = useAppSelector((state) => ({
    userVipInfo: state.user.userVipInfo,
  }));

  return useMemo(() => {
    return getVipType(userVipInfo?.vipList);
  }, [JSON.stringify(userVipInfo)]);
}
